import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/styles/main.scss'
import App from './App.vue'
import router from './router'
import i18n from './plugins/i18n'

createApp(App)
  .use(router)
  .use(ElementPlus)
  .use(createPinia())
  .use(i18n)
  .mount('#app')
